import React, {Component} from 'react';
import Dialog from '../../components/Dialog/Dialog';
import { withRouter } from "react-router";
import { compose } from 'redux';
import { connect } from 'react-redux';
import * as infoActions from '../../store/actions/infoDialogActions';
import InfoOutline from '@material-ui/icons/InfoOutlined';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
    dialogContent: {
        display: 'flex',
        alignItems: 'center',
        color: '#115293'
    },
    info: {
        color: '#115293'
    }
});

const mapStateToProps = (state) => {
    return {
        isDialogVisible: state.infoDialog.isDialogVisible,
        message: state.infoDialog.message,
    }
};
  
const mapDispatchToProps = (dispatch) => ({
    onClose: () =>
        dispatch(infoActions.closeInfoDialog()),   
});

class InfoDialogContainer extends Component {
    render() {
        return (
            <Dialog 
                open={this.props.isDialogVisible}
                onClose={this.props.onClose}
                className={this.props.classes.info} 
                cancelButtonText="OK"
                title="Information Dialog"
            >
                <div className={this.props.classes.dialogContent}>
                    <InfoOutline className={this.props.classes.info} />
                    <span>{this.props.message}</span>
                </div>
            </Dialog>
        )
    }
}
export default compose(withRouter, withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(InfoDialogContainer)
